// extracted by mini-css-extract-plugin
export default {"container":"drag-drop-container_container__cufV5","emptyColumn":"drag-drop-container_emptyColumn__qozk6","emptyMessage":"drag-drop-container_emptyMessage__2jUvY"};